import React, { Component, useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Badge } from 'reactstrap';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

const VendSystemAgreements = (props) => {

    const dispatch = useDispatch()
    const selectRedux = state => state;
    const reduxData = useSelector(selectRedux);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        getAgreements();
    }, []);

    useEffect(() => {
        getAgreements();
    }, [props.syspk])

    function getAgreements() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + reduxData.apiKey
        dispatch({ type: 'foundation/setFetchTime' })
        let toSend = {
            userLevel: reduxData.userInfo.level.pk,
            syspk: props.syspk
        }
        fetch('GetSystemAgreements', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR }, body: JSON.stringify(toSend) })
            .then((response) => response.json())
            .then((responseJSON) => { setTableData(responseJSON) })
        //localStorage.setItem("lastFetch", moment());
    }

    function isAfterToday(date) {//This nice little function I definitely didn't steal from StackOverflow returns true if the date provided is after today.
                                    //This works with datetime values lifted straight from Sql Server, which is nice.
        return new Date(date).valueOf() > new Date().valueOf();
    }

    return (<div>
        <Table>
            <thead>
                <tr>
                    <th>Payable To</th>
                    <th>Agreement #</th>
                    <th>Agreement Start</th>
                    <th>Description</th>
                    <th>Total Due</th>
                    <th>Term Name</th>
                    <th>Term Description</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map(item => (
                    <tr>
                        <td>{item.payable}</td>
                        <td>{item.agrnumber}</td>
                        <td style={{ color: !isAfterToday(item.enddate) ? "red" : "" }}>{item.startdate.substring(0, item.startdate.indexOf(' '))}</td>
                        <td>{item.descrip}</td>
                        <td>{item.totaldue}</td>
                        <td>{item.termname}</td>
                        <td>{item.termdesc}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>)

}

export default VendSystemAgreements;